<template>
  <div class="checkout-heading">
    <h6>Checkout</h6>
  </div>
</template>
<script>
export default {
  name: "CheckoutHeading",
};
</script>